<template>
    <section id="aboutus" class="aboutus-section" aria-label="Propósito">
        <div class="aboutus-content">
            <div class="aboutus-title">
                <span class="section-tag">Propósito</span>
                <h2 class="section-title-modern">Reduzir complexidade operacional com software confiável.</h2>
            </div>
            <div class="aboutus-copy">
                <p>
                    A Mazzitech constrói tecnologia para ambientes em que processos, dados e decisões
                    precisam caminhar com precisão. Nosso papel é entender a operação real de cada cliente
                    e criar sistemas que tragam controle, eficiência e rastreabilidade, com forte experiência
                    em cenários jurídicos, administrativos e de recuperação judicial.
                </p>
                <div class="purpose-grid">
                    <article v-for="item in items" :key="item.title" class="purpose-item">
                        <span>{{ item.number }}</span>
                        <strong>{{ item.title }}</strong>
                        <p>{{ item.description }}</p>
                    </article>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    number: "01",
                    title: "Clareza nos processos",
                    description: "Mapeamos rotinas e transformamos etapas críticas em fluxos digitais objetivos.",
                },
                {
                    number: "02",
                    title: "Segurança da informação",
                    description: "Projetamos soluções com cuidado para dados sensíveis, permissões e continuidade.",
                },
                {
                    number: "03",
                    title: "Eficiência operacional",
                    description: "Integramos sistemas e automatizamos tarefas para reduzir retrabalho e dependência manual.",
                },
            ],
        };
    },
};
</script>

<style lang="scss">
.aboutus-section {
    position: relative;
    background: #242424;
    padding: clamp(128px, 9vw, 168px) 0 112px;
    color: #ffffff;
    border-bottom: 1px solid #151515;
    overflow: hidden;
}

.aboutus-content {
    display: grid;
    grid-template-columns: minmax(320px, 440px) 1fr;
    gap: 84px;
    width: min(1260px, 78vw);
    margin: 0 auto;
}

.aboutus-title .section-title-modern {
    margin: 22px 0 0;
    color: #ffffff;
    font-size: clamp(2rem, 3.8vw, 3.35rem);
    font-weight: 700;
    line-height: 1.08;
    letter-spacing: 0;
}

.aboutus-section .section-tag {
    color: rgba(255, 255, 255, 0.6);
}

.aboutus-copy > p {
    margin: 0 0 28px;
    color: rgba(255, 255, 255, 0.74);
    font-size: 19px;
    line-height: 1.75;
}

.purpose-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    border: 1px solid rgba(255, 255, 255, 0.22);
}

.purpose-item {
    padding: 28px;
    background: #f7f7f5;
    border-right: 1px solid #cbcbc6;
}

.purpose-item:last-child {
    border-right: 0;
}

.purpose-item span {
    display: block;
    margin-bottom: 36px;
    color: #777771;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.14em;
}

.purpose-item strong {
    display: block;
    margin-bottom: 14px;
    color: #111111;
    font-size: 17px;
    line-height: 1.2;
}

.purpose-item p {
    margin: 0;
    color: #696963;
    font-size: 14px;
    line-height: 1.6;
}

@media (max-width: 960px) {
    .aboutus-content {
        grid-template-columns: 1fr;
        width: 88vw;
        gap: 36px;
    }

    .purpose-grid {
        grid-template-columns: 1fr;
    }

    .purpose-item {
        border-right: 0;
        border-bottom: 1px solid #cbcbc6;
    }
}
</style>
